import { file, nullable, object, string } from "../../../types/_types";

export const AgreementAppendix = object({
	file: nullable(file()),
	name: string(3),
	text: string(),
});
